<style>
@import '../../custom/css/editar-dica.css';
</style>

<template>
  <div class="editar-dica">
    <div class="form-fields position-relative" v-if="this.dica !== null">
      <h1 class="title text-uppercase font-weight-bold">Editar Dica</h1>
      <hr class="linha-amarela" />
      <div class="form-group">
        <label for="titulo">Título</label>
        <input
          type="text"
          class="form-control"
          id="titulo"
          v-model="dica[0].titulo"
        />
      </div>
      <div class="form-group">
        <label for="texto_1">Primeiro Texto</label>
        <ckeditor
          id="texto_1"
          :editor="editor1.type"
          v-model="dica[0].texto_1"
          :config="editor1.config"
        />
      </div>
      <div class="form-group">
        <label for="texto_2">Segundo Texto</label>
        <ckeditor
          id="texto_2"
          :editor="editor2.type"
          v-model="dica[0].texto_2"
          :config="editor2.config"
        />
      </div>
      <div class="form-group position-relative" v-if="dica[0].imagem !== null">
        <div class="btn-remove" @click="deleteImage()">
          <i class="fas fa-times"></i>
        </div>
        <div class="box-img mb-4 shadow h-auto">
          <img
            :src="`${getImagesAddress}` + dica[0].imagem"
            alt="Imagem da dica"
            class="obj-cover w-100"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="custom-file m-t-20">
          <input
            type="file"
            id="file"
            ref="file"
            class="custom-file-input"
            lang="pt"
            @change="addImage()"
            accept="image/x-png, image/gif, image/jpeg, image/jpg"
          />
          <label
            class="custom-file-label"
            for="file"
            v-if="dica[0].imagem === null"
            >Insira uma imagem de 1920px de largura e 500px de altura nesse
            campo!</label
          >
          <label class="custom-file-label" for="file" v-else>{{
            dica.imagem_name
          }}</label>
        </div>
      </div>
      <div class="form-group">
        <label for="video">Vídeo</label>
        <input
          type="text"
          class="form-control"
          id="video"
          v-model="dica[0].video"
        />
      </div>
      <div class="form-group">
        <label for="categorias_metatags">Categorias Metatags</label>
        <input
          type="text"
          class="form-control"
          id="categorias_metatags"
          v-model="dica[0].categorias_metatags"
        />
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="editSubject()">Editar</div>
        <div class="btn btn-voltar-dicas" @click="backToList()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Essa dica não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { mapGetters, mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';
import UploadAdapter from '../../utils/UploadAdapterAxios';

const UploadAdapterPlugin = (editor) => {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    const token = localStorage.getItem('token');
    return new UploadAdapter(loader, token);
  };
};

export default {
  name: 'editar-dica',
  mixins: [makeToast],
  data: () => ({
    editor1: {
      type: ClassicEditor,
      config: {
        extraPlugins: [UploadAdapterPlugin],
      },
    },
    editor2: {
      type: ClassicEditor,
      config: {
        extraPlugins: [UploadAdapterPlugin],
      },
    },
  }),
  props: ['id'],
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getInformacaoUpload',
    ]),
    ...mapState({
      dica: (state) => state.dica,
    }),
  },
  created() {
    this.$store.dispatch('showDica', this.id);
  },
  activated() {
    this.$store.dispatch('showDica', this.id);
  },
  methods: {
    editSubject() {
      this.$store.dispatch('updateDica', this.dica).then(() => {
        setTimeout(() => {
          if (this.getTipoNotification === 1) {
            this.makeToast('Sucesso!', this.getNotification, 'success');
            setTimeout(() => {
              this.$router.push({ name: 'administrador-lista-dicas' });
            }, 1500);
          } else if (this.getTipoNotification === 3) {
            this.makeToast('Oopss!', this.getNotification, 'danger');
          }
        }, 1000);
      });
    },
    deleteImage() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('files/deleteFile', this.dica[0].imagem)
        .then(() => {
          this.makeToast('Sucesso', 'Imagem deletada!');
          this.dica[0].imagem = null;
        })
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Houve algo de errado ao excluir a imagem!',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    addImage() {
      const formData = new FormData();
      this.dica.imagem = this.$refs.file.files[0];
      formData.append('file', this.dica.imagem);

      this.$store.dispatch('files/sendUploadFiles', formData)
        .then((data) => {
          this.$store.dispatch('startLoader');
          this.dica[0].imagem = data.data.data;
          this.makeToast(
            'Sucesso!',
            'A foto da dica foi inserida com sucesso!',
            'success'
          );
        })
        .catch(() => {
          this.makeToast(
            'Oops!',
            'Não foi possível inserir sua imagem, tente novamente em 5 minutos!',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    },
    backToList() {
      this.$router.push({
        name: 'administrador-lista-dicas',
      });
    },
  },
};
</script>
